export default "__VITE_ASSET__Yjp_$T6z__"